import { render } from "./MessageFile.vue?vue&type=template&id=7357dae4&scoped=true&ts=true"
import script from "./MessageFile.vue?vue&type=script&lang=ts"
export * from "./MessageFile.vue?vue&type=script&lang=ts"

import "./MessageFile.vue?vue&type=style&index=0&id=7357dae4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7357dae4"]])

export default __exports__